import { Route, Routes } from "react-router-dom";
import style from "./style.module.css"
import Dashboard from "./Dashboard/index"
import ProtectedRoute from "../../components/ProtectedRoute/ProtectedRoute";
import Exams from "./Exams";
import SystemCheck from "./SystemCheck";
import AttemptExam from "./AttemptExam";
import Footer from "../../components/Footer"
import ClassInformation from "./ClassInformation";
import Results from "./Results";
import SingleResult from "./Results/SingleResult";
const Student = () => {
    return (
        <>
            <div className={style.mainDiv}>
                <Routes>
                    <Route path="/" element={<ProtectedRoute component={Dashboard} />} />
                    <Route path="/exams" element={<ProtectedRoute component={Exams} />} />
                    <Route path="/systemCheck" element={<ProtectedRoute component={SystemCheck} />} />
                    <Route path="/attemptExam" element={<ProtectedRoute component={AttemptExam} />} />
                    <Route path="/classInfo" element={<ProtectedRoute component={ClassInformation} />} />
                    <Route path="/results" element={<ProtectedRoute component={Results} />} />
                    <Route path="/result/:_id" element={<ProtectedRoute component={SingleResult} />} />

                </Routes>
                <Footer />
            </div>
        </>
    )
}


export default Student;